/**************************************************
 * Nombre:       Formulario_Metricas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    BakeryDining,
    CalendarMonthOutlined,
    Google,
    NumbersOutlined,
    PhoneAndroid
} from "@mui/icons-material";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";
import {useEffect, useState} from "react";
import Tarjeta_Producto_Metrica from "../Tarjeta/Tarjeta_Producto_Metrica";

const Formulario_Metricas = ({...props}) => {
    const [productos, setProductos] = useState([]);

    useEffect(() => {

        let productos = props.props.getValues('productos')
        if (productos && productos.length > 0) {
            setProductos(productos);
        }

    }, [props.props.watch('productos')]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoFecha Icono={CalendarMonthOutlined} nombre={'Ultima Visita'} dato={'fecha'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={NumbersOutlined} nombre={'Ultima Visita'} dato={'vistaPagina'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={PhoneAndroid} nombre={'Celular'} dato={'celular'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoFecha Icono={BakeryDining} nombre={'fechaCumple'} dato={'fechaCumple'} {...props}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={Google} nombre={'Correo de Google'} dato={'correo'} {...props}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    {productos.map((it, index) => (
                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Tarjeta_Producto_Metrica item={it}/>
                        </Grid>
                    ))}
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Metricas